/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {findMerchants} from '../api'

export const useMutationFindMerchants = createReactQueryMutationHook('findMerchants', findMerchants)
